import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { useScenarioDetailsContext } from '@app-velocity/modules/scenarios';

const ChallengePromptContainer = styled('div')(({ theme }) => ({
  // maxHeight: 44,
  overflow: 'hidden',
}));

const ChallengePrompt = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  lineHeight: '22px',
  fontWeight: 500,
  letterSpacing: '-0.2px',
}));

const Section = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const TaskDescription = () => {
  const { scenario } = useScenarioDetailsContext();
  // const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <Section>
      <ChallengePromptContainer>
        <ChallengePrompt>{scenario.introMessage}</ChallengePrompt>
      </ChallengePromptContainer>
    </Section>
  );
};
